module.exports = require("./uz-Arab.js");